import { MATERIAL_URL } from '@/api/handbook/warehouse/Material/MaterialApi'
import { getAll } from '@/api/request'
import { setAlertError } from '@/utils/store/alert'
import { W_MATERIAL_URL } from '@/api/warehouse/material/MaterialApi'
import { getResponseList, getResponsePayload } from '@/utils/apiResponse'

const getResponseTree = (data) => {
  const payload = getResponsePayload(data)
  if (Array.isArray(payload)) return { items: payload }
  if (Array.isArray(payload?.items)) return payload
  return { items: [] }
}

const normalizeMaterials = (materials) => {
  if (Array.isArray(materials)) return { items: materials }
  if (materials && typeof materials === 'object') {
    return {
      ...materials,
      items: Array.isArray(materials.items) ? materials.items : []
    }
  }

  return { items: [] }
}

export default {
  namespaced: true,
  state: {
    url: MATERIAL_URL,
    urlTree: W_MATERIAL_URL + '/tree',
    urlFilter: W_MATERIAL_URL + '/filters',
    materials: {
      items: []
    },
    filterOptions: {
      materials: [],
      d_wires: []
    },
    filter: {},
    isLoading: false
  },

  getters: {
    materials: state => state.materials,
    filterOptions: state => state.filterOptions,
    filter: state => state.filter,
    isLoading: state => state.isLoading
  },

  mutations: {
    SET_MATERIALS (state, materials) {
      state.materials = normalizeMaterials(materials)
    },
    SET_IS_LOADING (state, loading) {
      state.isLoading = loading
    },

    SET_FILTER_OPTIONS (state, data) {
      state.filterOptions = {
        materials: Array.isArray(data?.materials) ? data.materials : [],
        d_wires: Array.isArray(data?.d_wires) ? data.d_wires : []
      }
    },

    SET_FILTER (state, data) {
      state.filter = data
    },

    RESET_FILTER (state) {
      state.filter = {}
    }
  },
  actions: {
    async getMaterials ({ state, commit }) {
      try {
        commit('SET_IS_LOADING', true)
        const params = { ...state.filter }
        const response = await getAll(state.url, params)
        commit('SET_MATERIALS', { items: getResponseList(response.data) })
      } catch (e) {
        await setAlertError(e, 'Не удалось загрузить список материалов')
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    // Получение дерева материалов
    async getMaterialsTree ({ state, commit }) {
      try {
        commit('SET_IS_LOADING', true)
        const params = {
          ...state.filter
        }
        const response = await getAll(state.urlTree, params)
        commit('SET_MATERIALS', getResponseTree(response.data))
      } catch (e) {
        await setAlertError(e, 'Не удалось загрузить список материалов')
      } finally {
        commit('SET_IS_LOADING', false)
      }
    },

    // Получение фильтров для материалов
    async getMaterialsFilters ({ state, commit }) {
      try {
        const response = await getAll(state.urlFilter)
        commit('SET_FILTER_OPTIONS', getResponsePayload(response.data))
      } catch (e) {
        await setAlertError(e, 'Не удалось загрузить данные для фильтра')
      }
    }
  }
}
